"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePictureFromGallery } from "@/lib/actions/gallery/delete/deletePictureFromGallery";

const serverDeletePictureFromGallery = async (id: string) => {
  const response = await deletePictureFromGallery(id);
  return response;
};

export const useDeletePictureFromGallery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: serverDeletePictureFromGallery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gallery"] });
    },
  });
};
